import React from 'react';
import { Checkbox, Popconfirm } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import moment from 'moment';

export const driverlessPRColumns = (context) => [
    {
        title: 'STT',
        dataIndex: 'index',
        key: 'index',
        fixed: true,
        className: 'column-60 inherit-background',
        editable: false,
    },
    {
        title: 'Ngày',
        fixed: true,
        dataIndex: 'date',
        key: 'date',
        editable: false,
        className: 'column-80 inherit-background',
        render: date => {
            return <div>{date}</div>
        }
    },
    {
        title: 'Số km bắt đầu',
        dataIndex: 'km_start',
        editable: true,
        key: 'km_start',
        isPercent: false,
        inputType: 'input-number'
    },
    {
        title: 'Số km kết thúc',
        dataIndex: 'km_end',
        editable: true,
        key: 'km_end',
        isPercent: false,
        inputType: 'input-number'
    },
    {
        title: 'Số km đã đi',
        dataIndex: 'used_km',
        editable: false,
        key: 'used_km',
        isPercent: false,
        inputType: 'input-number'
    },
    {
        title: 'Over km (Km)',
        dataIndex: 'over_km',
        editable: false,
        key: 'over_km',
        inputType: 'input-number'
    },
    {
        title: 'Tài xế',
        dataIndex: 'driver_name',
        editable: true,
        key: 'driver_name',
        inputType: 'input-text',
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
    {
        title: 'Biển KS',
        dataIndex: 'vehicle_number_plate',
        editable: true,
        key: 'vehicle_number_plate',
        inputType: 'input-text',
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
    {
        title: 'Ghi chú',
        className: 'column-200 noteMW',
        dataIndex: 'note',
        editable: true,
        key: 'note',
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
];

const styles = {
    mr8: {
        marginRight: 8
    }
}